import ContactForm from './ContactForm';

export default function Contact() {
  return (
    <section className="px-5 py-10 max-w-xl mx-auto" id="contact">
      <div className="bg-surface-dark border border-slate-800 rounded-3xl p-6 relative overflow-hidden shadow-2xl">
        <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-primary to-transparent"></div>
        
        <h2 className="text-xl font-bold text-white mb-1">Get in Touch</h2>
        <p className="text-slate-400 text-xs mb-6">Visit us at Manakwal Road, Ludhiana</p>

        <ContactForm />
      </div>
    </section>
  );
}